import React from 'react'
import styled from 'styled-components'

import type {PanelProps} from '@/components/panel'
import {Panel} from '@/components/panel'
import type {Props as PrismicLinkProps} from '@/components/prismic-link'
import PrismicLink from '@/components/prismic-link'
import {Text} from '@/components/text'
import {Section} from '@/styles/grid'
import {tokens} from '@/theme'
import mq from '@/utils/media-query'

interface Item extends Omit<PanelProps, 'CTA'> {
    ctaText: string
    ctaLink: PrismicLinkProps
}

export interface Props {
    title: string
    excerpt: string
    items: Item[]
}

export const PanelGrid = ({title, excerpt, items}: Props) => (
    <Wrapper>
        <CopyWrapper>
            <Text $variant="heading-large">{title}</Text>
            <Text $variant="paragraph-large" $color="muted">
                {excerpt}
            </Text>
        </CopyWrapper>

        {items.map(({labelColor, labelText, heading, excerpt, ctaLink, ctaText}, index) => (
            <Panel
                key={index}
                labelColor={labelColor}
                labelText={labelText}
                heading={heading}
                excerpt={excerpt}
                CTA={(props) => (
                    <PrismicLink {...props} {...ctaLink}>
                        {ctaText}
                    </PrismicLink>
                )}
            />
        ))}
    </Wrapper>
)

const Wrapper = styled(Section)`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing20};

    ${mq.min('sm')} {
        gap: ${tokens.spacing24};
    }

    ${mq.min('md')} {
        gap: ${tokens.spacing40};
    }
`

const CopyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing10};

    ${mq.min('sm')} {
        gap: ${tokens.spacing20};
        margin-bottom: ${tokens.spacing16};
    }

    ${mq.min('md')} {
        margin-bottom: 0;
        max-width: 540px;
    }
`
